import { render, staticRenderFns } from "./PopUpCommentsFile.vue?vue&type=template&id=f5a56258&"
import script from "./PopUpCommentsFile.vue?vue&type=script&lang=js&"
export * from "./PopUpCommentsFile.vue?vue&type=script&lang=js&"
import style0 from "./PopUpCommentsFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5a56258')) {
      api.createRecord('f5a56258', component.options)
    } else {
      api.reload('f5a56258', component.options)
    }
    module.hot.accept("./PopUpCommentsFile.vue?vue&type=template&id=f5a56258&", function () {
      api.rerender('f5a56258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpCommentsFile.vue"
export default component.exports